const gql = {
  query: `query userProfile {
    getUserProfile {
      contacts
      profile {
        firstName
        middleName
        lastName
        email
      }
      roles
    }
  }`,
  meta: {
    label: "Get MFA Contacts",
  },
};

export default gql;
